module.exports = __webpack_public_path__ + "static/media/rom24.0f0343c9.jpg";